import { RRule } from 'rrule';
import { RecurrenceWeekdayData, RecurrenceWeekdayNumber } from './../types';

export const RECURRENCE_FREQUENCY_OPTIONS = [
  { id: RRule.DAILY, title: 'Days' },
  { id: RRule.WEEKLY, title: 'Weeks' },
  { id: RRule.MONTHLY, title: 'Month' },
  { id: RRule.YEARLY, title: 'Years' },
];

export const RECURRENCE_INTERVAL_OPTIONS = [
  { id: 1, title: '1' },
  { id: 2, title: '2' },
  { id: 3, title: '3' },
  { id: 4, title: '4' },
  { id: 5, title: '5' },
  { id: 6, title: '6' },
  { id: 7, title: '7' },
];

export const RECURRENCE_WEEKDAYS: Record<
  RecurrenceWeekdayNumber,
  RecurrenceWeekdayData
> = {
  [RecurrenceWeekdayNumber.SUNDAY]: {
    id: RecurrenceWeekdayNumber.SUNDAY,
    label: 'S',
    name: 'Sunday',
  },
  [RecurrenceWeekdayNumber.MONDAY]: {
    id: RecurrenceWeekdayNumber.MONDAY,
    label: 'M',
    name: 'Monday',
  },
  [RecurrenceWeekdayNumber.TUESDAY]: {
    id: RecurrenceWeekdayNumber.TUESDAY,
    label: 'T',
    name: 'Tuesday',
  },
  [RecurrenceWeekdayNumber.WEDNESDAY]: {
    id: RecurrenceWeekdayNumber.WEDNESDAY,
    label: 'W',
    name: 'Wednesday',
  },
  [RecurrenceWeekdayNumber.THURSDAY]: {
    id: RecurrenceWeekdayNumber.THURSDAY,
    label: 'T',
    name: 'Thursday',
  },
  [RecurrenceWeekdayNumber.FRIDAY]: {
    id: RecurrenceWeekdayNumber.FRIDAY,
    label: 'F',
    name: 'Friday',
  },
  [RecurrenceWeekdayNumber.SATURDAY]: {
    id: RecurrenceWeekdayNumber.SATURDAY,
    label: 'S',
    name: 'Saturday',
  },
};

export const RECURRENCE_WEEKDAY_IDS = Object.keys(RECURRENCE_WEEKDAYS).map(
  (w) => parseInt(w)
);

export const NON_WEEKEND_RECURRENCE_WEEKDAY_IDS = RECURRENCE_WEEKDAY_IDS.filter(
  (w) => w < 5
);